import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ children }) => {
  const { pathname } = useLocation();
  const isInitialRender = useRef(true);

  useEffect(() => {
    // componentDidUpdate never ran on mount; custom-render wraps every test in ScrollToTop, so skip the first pass.
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    window.scrollTo(0, 0);
  }, [pathname]);

  return children;
};

export default ScrollToTop;
